import './App.css'
import './font.css'
import { Experimental_CssVarsProvider as CssVarsProvider } from '@mui/material/styles';
import RouterComponent from './Router';
import ErrorBoundary from './components/ErrorBoundary';
import { createTheme } from './theme/createTheme';
import React from 'react';
function App() {
	const theme = createTheme();
	return (
		<CssVarsProvider theme={theme}>
			<ErrorBoundary>
				<RouterComponent />
			</ErrorBoundary>
		</CssVarsProvider>
	);
}

export default App;
